
import { includeNewRetirementFundsForDivCap } from 'services/FeatureFlags';

const retirementIncomeTRPCodes = ['RIB']

if(includeNewRetirementFundsForDivCap()) {
  const newTrpCodes = ['RIC', 'NIC', 'INB'];

  retirementIncomeTRPCodes.push(...newTrpCodes);
}

export const isRetirementFund = (account) => {
  return (
    account &&
    retirementIncomeTRPCodes.includes(account.trpCode) &&
    account.retirementAccount === true
  );
};

export const isRetirementIncome = (trpCode) => {
    return retirementIncomeTRPCodes.includes(trpCode);
};

export const getRetirementIncomeTitle = () => {
  if (includeNewRetirementFundsForDivCap()) {
    return 'Retirement Income Funds';
  }
  return 'Retirement Income 2020 Funds';
};
